import script from "./check.vue?vue&type=script&setup=true&lang=js"
export * from "./check.vue?vue&type=script&setup=true&lang=js"

import "./check.vue?vue&type=style&index=0&id=63d18a1a&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d18a1a"]])

export default __exports__